<template>
  <div>
    <el-container class="SelectBlock">


      <el-col class="FirstBlock" :sapn="3" >
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            选择查询的需要<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">根据资产名称查询</el-dropdown-item>
            <el-dropdown-item command="b">根据存放区域查询</el-dropdown-item>
            <el-dropdown-item command="c">根据盘点状态查询</el-dropdown-item>

          </el-dropdown-menu>
        </el-dropdown>


          <el-input v-if="selectCheck == 'a'" v-model="SForm.SpropertyName" placeholder="根据资产名称查询"></el-input>


          <el-input v-if="selectCheck == 'b'" v-model="SForm.SplaceId" :value="SForm.SplaceRealId"
          append-to-body
          style="width: 250px;"
          placeholder="根据存放的区域查询">
              <el-button
                size="mini"
                 style="margin-top: 5px;"
                 slot="suffix"
                 type="text"
                @click="dialogPlace = true">选择</el-button></el-input>
                <el-dialog title="选择资产存放区域" :visible.sync="dialogPlace" width="35%">
                  <el-tree
                    class ="TreeBlock"
                    :data="PlaceData"
                    :filter-node-method="filterNode"
                    node-key="id"
                    @node-click="TreePlaceClick"
                    ref="tree"
                    :props="defaultProps"
                    default-expand-all:false
                    :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>

                    </span>
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogPlace = false">取 消</el-button>
                    <el-button type="primary" @click="dialogPlace = false;">确 定</el-button>
                  </div>
                </el-dialog>







          <el-select v-if="selectCheck == 'c'" v-model="SForm.SpropertyState" placeholder="根据资产状态查询">
            <el-option label="待审核" value='1'></el-option>
            <el-option label="已完成" value='2'></el-option>
            <el-option label="已驳回" value='3'></el-option>


          </el-select>






        <el-button type="primary" @click="select(1)">查询</el-button>
        <el-button type="primary" @click="resetForm('SForm')">重置</el-button>
      </el-col>
    </el-container>

    <el-contianer>

      <el-table
        :data="tableData"
        border
         @selection-change="handleSelectionChange"
        style="width: 98%;margin-top: 5%; margin-left: 1%;"
        >
        <el-table-column
              type="selection"
              width="55">
            </el-table-column>


        <el-table-column
          label="异常ID"
          prop="id">
        </el-table-column>
        <el-table-column
          label="资产固定编码"
          prop="propertyCode">
        </el-table-column>
        <el-table-column
          label="资产名称"
          prop="propertyName">
        </el-table-column>
        <el-table-column
          label="盘点状态"
          prop="exceptopnState"
          >
          <template slot-scope="scope">
            <el-tag
            :type="scope.row.exceptionState == 1?''
            :(scope.row.exceptionState==2?'success'
            :(scope.row.exceptionState==3?'info'
            :(scope.row.exceptionState==4?'danger'
            :(scope.row.exceptionState==5?'danger':'warning'))))"
            effect="dark">
              <div v-if="scope.row.exceptionState == 1">盘亏</div>
              <div v-if="scope.row.exceptionState == 2">盘盈</div>
              <div v-if="scope.row.exceptionState == 3">损毁待报废</div>
              <div v-if="scope.row.exceptionState == 4">闲置</div>
              <div v-if="scope.row.exceptionState == 5">信息不一致</div>


            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="审核人"
          prop="checker">
        </el-table-column>

        <el-table-column
          label="盘点任务名"
          prop="belongCheck">
        </el-table-column>
        <el-table-column
          label="盘点单名"
          prop="belongCheckTask">
        </el-table-column>





        <el-table-column label="操作">
              <template slot-scope="scope">
                  <el-button type="text" @click="table = true;getImage(scope.row.photo)">详情</el-button>


                  <el-drawer
                    title="资产详情!"
                    :visible.sync="table"
                    direction="rtl"
                    size="50%">


                    <el-descriptions border :column="2" style="width: 95%;margin-left: 2%;">
                        <el-descriptions-item label="盘点异常发现人">{{scope.row.finder}}</el-descriptions-item>
                        <el-descriptions-item label="默认区域">{{scope.row.holdPlace}}</el-descriptions-item>
                        <el-descriptions-item label="所属公司">{{scope.row.unit}}</el-descriptions-item>
                        <el-descriptions-item label="资产类型">{{scope.row.propertyType}}</el-descriptions-item>


                        <el-descriptions-item label="盘点任务状态">
                            <div v-if="scope.row.state == 1">待审核</div>
                            <div v-if="scope.row.state == 2">已完成</div>
                            <div v-if="scope.row.state == 3">已驳回</div>
                       </el-descriptions-item>


                    </el-descriptions>
                    <h1>留证图片</h1>
                   <el-image
                          style="width: 500px; height: 500px"
                          :src="url"></el-image>

                  </el-drawer>
              </template>
            </el-table-column>

      </el-table>

    </el-contianer>
    <div class="block">
             <el-pagination
               @size-change="select"
               @current-change="select"
               :current-page.sync="currentPage"
               :page-size="10"
               layout="prev, pager, next, jumper"
               :total="pageSize">
             </el-pagination>
           </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'CheckErrorData',
     data () {
       const PlaceData = [{
               id: 1,
               label: '一级 1',
               children: [{
                 id: 4,
                 label: '二级 1-1',
                 children: [{
                   id: 9,
                   label: '三级 1-1-1'
                 }, {
                   id: 10,
                   label: '三级 1-1-2'
                 }]
               }]
             }];
       return {
         dialogPlace:false,
         defaultProps: {
                  children: 'children',
                  label: 'label'
                },
         table:false,
         dialogFormEdit:false,
        pageSize:5,
        url:'https://assert.hyhdit.com/api',
        SForm:{
          SpropertyName:'',
          SplaceId:'',
          SpropertyState:'',
        },
        selectCheck:'',

        tableData: [{
                id:'',
                placeId:'',
                checkerId:'',
                findId:'',
                checkId:'',
                taskId:'',
                unitId:'',
                state:'',
                photo:'',
                exceptionState:'',
                propertyName:'',
                propertySpecification:'',
                propertyModel:'',
                supplier:'',
                del:'',
                msg:'',
                createDate:'',
                holdPlace:'',
                placeMgr:'',
                checker:'',
                finder:'',
                belongCheck:'',
                belongCheckTask:'',
                unit:'',
                propertyType:'',
              }],
        };
     },
     mounted:function() {
       this.showData();
       this.showPlaceData();
     },
     methods: {
       // 获取区域信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是区域ID
       TreePlaceClick(data){
           this.SForm.SplaceRealId = data.id
           this.SForm.SplaceId = data.label
       
       },
       
       filterNode(value, data) {

               if (!value) return true;
               return data.label.indexOf(value) !== -1;
             },
		// 下拉菜单存放点击时选中的数据
       handleCommand(command) {
              this.selectCheck = command
             },
		// 重置数据
      resetForm(formName) {
        Object.assign(this.$data.SForm, this.$options.data().SForm)
        this.select()
          },
		  
		  
	   	   // 重写图片路由链接
       getImage(row){
         this.url = "https://assert.hyhdit.com"+row
       },
		// 根据条件查询
       select(val){
          var authorization = Cookies.get("Authorization");
          var paramsData = {
            currentPage: val || 1 ,
            pageSize: 10,
            placeId:this.SForm.SplaceId || undefined,
            state:this.SForm.SpropertyState || undefined,
            propertyName:this.SForm.SpropertyName || undefined,
          }

           this.axios({
               method: 'POST',
               url: '/check/errorShow',
               data:paramsData,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
                this.tableData=resp.data.data;
                this.pageSize = resp.data.count;
             })
       },
	  // 请求小杜接口public/getTree获取区域信息然后将数据传给PlaceData
      showPlaceData(){
       var authorization = Cookies.get("Authorization");
       var params = {
         currentPage: 1,
         pageSize: 5,
       }
        this.axios({
            method: 'GET',
            url: '/public/getTree',

            header:{
             'Authorization':authorization,
            	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{

           this.PlaceData=resp.data.data;
          })
      },

       // 主要数据在表格里展示
       showData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          currentPage: 1,
          pageSize: 10,
        }
         this.axios({
             method: 'POST',
             url: '/check/errorShow',
             data:params,
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{
            this.tableData=resp.data.data;
            this.pageSize = resp.data.count;
           })
       },

     }
   }
</script>

<style>
  .SelectBlock .el-input{
    width: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Check/CheckErrorData.vue